var SpotModel = require("../models/SpotModel");
var AbstractWS = require("./AbstractWS");
var xmlToJson = require("../helpers/xmlToJson");

/**
 * @description Service to search for a consumer by phone or name
 * @method ConsumerSearchWS
 * @param { ViewModel } viewModel the application's main ViewModel is the parent object of the Web Service
 * @returns { ConsumerSearchWS } returns itself as API
 */
function ConsumerSearchWS(viewModel) {
  var self;

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self = this;
  self.name = 'ConsumerSearchWS';			// Convenience name for debugging
  self.BASE_URL = "/qless/api/v1/employee/queues/"
  self.spots = ko.observableArray([]);

  // over-ride serviceURL to be a simple observable
  // this makes it easy to change depending on the search type
  // while staying compatible with AbstractWS
  self.serviceURL = ko.observable()

	/**
	 * Abstract override method
	 *
	 * @method doRequest
   * @param {Boolean} searchByCustomField wheter to search by nameOrPhoneField or by a custom field
	 * @param {Function} onSuccess
   * @param {Function} onerror
   * @param {Function} onFinally
	 * @returns none
	 */
  self.doRequest = function (onSuccess, onError, onFinally) {
    AbstractWS.prototype.doRequest.call(self, onSuccess, onError, onFinally);
  };

  /**
   * Search queues on `customProp` to find Spots with a `customProp` value matching `query`.
   * 
   * @param {Array<string>} queueIds
   * @param {string} query
   * @param {string | null | undefined} customProp search request parameters
   */
  self.searchByCustomProp = function(queueIds, customProp, query, onSuccess, onError, onFinally) {
    self.clearParams();

    self.serviceURL(self.BASE_URL +  "search");

    self.addParam("queueIds", queueIds.join(","));
    self.addParam("query", query);
    self.addParam("customProp", customProp);

    self.doRequest(onSuccess, onError, onFinally);
  }

  /**
   * Search Waiting Consumers by Name or Last 4 digits of Phone Number
   * 
   * N.B. This is the original Search API
   * 
   * @param queueIds Array<string>
   * @param query string
   * @param onSuccess function
   * @param onError function
   * @param onFinally function
   */
  self.searchWaiting = function(queueIds, query, onSuccess, onError, onFinally) {
    self.clearParams();

    self.serviceURL(self.BASE_URL + queueIds.join(",") + "/searchWaiting");

    self.addParam("query", query);
    self.doRequest(onSuccess, onError, onFinally);
  }

	/**
	 * Converts returned XML data into SpotModels, with custom properties
	 *
	 * @method processData
	 * @param {XMLString} xmlData
	 * @returns {ConsumerSearchWS}practice
	 */
  self.processData = function (xmlData) {
    var aSpots = [],
      tSpots = [];

    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, xmlData);

    var json = xmlToJson.parse(xmlData);

    // Only proceed if spots data was returned
    if (json && json.queueSpots && json.queueSpots.spot) {
      // Make sure that spot is an array
      var aSpots = Array.makeArray(json.queueSpots.spot);

      aSpots.forEach(function (s) {
        var spotModel = new SpotModel(s);

        // Grab the associated queue and location models
        var q = vm.queuesWS.getQueueById(spotModel.queueId);
        var l = vm.locationsWS.getLocationById(q.locationId);

        // Add some properties to the default SpotModel for convenience
        spotModel.usePartySize = l.usePartySize;
        spotModel.locationName = l.name;
        spotModel.queueName = q.description;

        // TODO - replace this
        spotModel.size = null;

        tSpots.push(spotModel);
      });
    }

    self.spots(tSpots);

    // Return self (ConsumerSearchWS) to be chainable, for best practice
    return self;
  };

  // Return self as API
  return self;
}

ConsumerSearchWS.prototype = AbstractWS.prototype;
ConsumerSearchWS.prototype.constructor = ConsumerSearchWS;

module.exports = ConsumerSearchWS
